import routes from 'js/core_pre_webpack/routes';
import { currentUser } from 'js/utils/user';

import type { PremiumUpsells } from '../../types';

export type Segment = {
  source: string;
  url: string;
  copy: string;
  extra?: object;
  controlClickSource?: string;
};

export function segmentFor(
  premiumUpsells?: PremiumUpsells,
  triggerOverride?: string,
): Segment | null {
  const churnedDiscount = premiumUpsells?.churnedUserReactivationDiscount;
  if (churnedDiscount) {
    return {
      source: 'reactivate_button',
      url: routes.checkout_path({
        feature: 'churned_user_reactivation',
        trigger: triggerOverride ?? 'reactivate_button',
        from_navbar: true,
      }),
      copy:
        churnedDiscount.offer === 'discount'
          ? `Reactivate Premium, ${churnedDiscount.value} OFF`
          : `Reactivate Premium for ${churnedDiscount.value}`,
      extra: { offer: churnedDiscount.offer },
      controlClickSource: 'churned_user_reactivation_button',
    };
  }

  if (premiumUpsells?.trialPricingCopy) {
    return {
      source: 'nav-btn-trial',
      url: routes.checkout_url({
        feature: 'default',
        trigger: triggerOverride ?? 'nav-btn-trial',
        from_navbar: true,
      }),
      copy: premiumUpsells.trialPricingCopy,
    };
  }

  if (premiumUpsells?.reactivatePremiumUpsellType) {
    return {
      source: 'nav-btn-reactivate',
      url: routes.checkout_url({
        feature: 'default',
        trigger: triggerOverride ?? 'nav-btn-reactivate',
        premium_discount_coupon: premiumUpsells.halfOffCoupon,
        from_navbar: true,
      }),
      copy: 'Reactivate Premium 50% OFF',
    };
  }

  const newUserDiscount = premiumUpsells?.newUserDiscount;
  if (newUserDiscount) {
    if (currentUser?.created_at === undefined) {
      return null;
    }
    return {
      source: newUserDiscount.trigger,
      url: routes.checkout_url({
        feature: newUserDiscount.feature,
        trigger: triggerOverride ?? newUserDiscount.trigger,
        coupon_code: newUserDiscount.couponCode,
      }),
      copy: 'UPGRADE & GET 6 MONTHS FREE!',
    };
  }

  return {
    source: 'default',
    url: routes.upgrade_url({
      feature: 'default',
      trigger: triggerOverride ?? 'default',
      from_navbar: true,
    }),
    copy: 'Get Premium',
  };
}
